import React from "react";
import { Field } from "formik";
import { toCamelCase } from "components/collections/util/format";
import l from "components/util/l";

const ViewField = ({
  idx,
  view,
  values,
  setFieldValue,
}) => {

  let mainViews = values?.views?.filter(v => v.is_main) || [];
  const mainViewsCount = mainViews.length;

  return <>
    <tr
      key={`field-view-${idx}`}
      style={{ background: idx % 2 ? "#f9f9f9" : "#fff" }}
    >

      <td>
        <i className="fas fa-home text-accent" title={l("Vista principal%PA078")}
          style={{ visibility: view.is_main ? "visible" : "hidden" }}></i>
      </td>

      {/* Name */}
      <td>
        <input
          type="text"
          name={`label_${idx}`}
          id={`label_${idx}`}
          className={"form-control"}
          style={view.is_prebuilt ? { caretColor: "transparent", userSelect: "none", cursor: "pointer" } : {}}
          placeholder={l("Nombre de la vista%PA077")}
          value={view.label}
          onClick={(e) => {
            setFieldValue("selected_view", idx);
          }}
          onChange={(e) => {

            if (view.is_prebuilt)
              return;

            setFieldValue(
              "views",
              values?.views?.map((f, i) => {
                if (i == idx) return {
                  ...f,
                  label: e.target.value,
                  name: !view.is_prebuilt ? toCamelCase(e.target.value) : f.name
                };
                return f;
              })
            );

          }}
        />
      </td>

      {/* Move buttons */}
      <td>
        <div class="btn-group" role="group">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            disabled={idx == 0}
            onClick={() => {
              let auxViews = values?.views ?? [];
              let newViews = [...auxViews];
              let tmpViews = newViews[idx - 1];
              newViews[idx - 1] = newViews[parseInt(idx)];
              newViews[parseInt(idx)] = tmpViews;
              setFieldValue("views", newViews);
              setFieldValue("selected_view", null);
            }}
          >
            <i class="fas fa-arrow-up"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            disabled={idx == values?.views?.length - 1}
            onClick={() => {
              let auxViews = values?.views ?? [];
              let newViews = [...auxViews];
              let tmpViews = newViews[idx + 1];
              newViews[idx + 1] = newViews[parseInt(idx)];
              newViews[parseInt(idx)] = tmpViews;
              setFieldValue("views", newViews);
              setFieldValue("selected_view", null);
            }}
          >
            <i class="fas fa-arrow-down"></i>
          </button>
          <button
            type="button"
            className={"btn btn-sm " +
              (!values?.views[idx]?.is_hidden ? "btn-outline-secondary " : "btn-secondary ")}
            onClick={() => {
              setFieldValue("views", values?.views?.map((f, i) => {
                if (i == idx) return { ...f, is_hidden: !f.is_hidden };
                return f;
              }));
            }}
          >
            <i className={`fas ${values?.views[idx]?.is_hidden ? "fa-eye-slash" : "fa-eye"}`}></i>
          </button>
        </div>
      </td>

      {/* Delete button */}
      <td>
        <button
          type="button"
          class="btn btn-sm btn-outline-danger"
          style={{ visibility: view.is_prebuilt ? "hidden" : "visible" }}
          onClick={() => {
            setFieldValue("views", values?.views?.filter((_, i) => i != idx));
            setFieldValue("selected_view", null);
          }}
        >
          <i class="fas fa-trash"></i>
        </button>
      </td>

    </tr>

    {
      (values.selected_view == idx) &&
      <tr
        style={{
          background: idx % 2 ? "#f9f9f9" : "#fff",
        }}
      >
        <td colSpan="4">
          <div className="d-flex flex-column justify-content-start px-2">

            {/* Primary view options */}
            <div className="w-100 mt-2 mb-2 ml-5">
              <div className="d-flex justify-content-start align-items-center">
                <input
                  type="checkbox"
                  className="from-control mr-2"
                  checked={view?.is_main}
                  onChange={(e) => {

                    let views = values?.views ?? [];
                    const isChecked = e.target.checked;

                    if (isChecked) {

                      let position = "left";
                      let weight = 100;
                      let removedView = false;

                      if (mainViewsCount == 2) {
                        removedView = true;
                        views = views.map(v => {
                          if (v.is_main && v.settings?.position === "right")
                            return { ...v, is_main: false, settings: {} };
                          return v;
                        });
                      }

                      let updatedMainViews = views?.filter(v => v.is_main);
                      const updatedMainViewsCount = updatedMainViews.length;

                      if (removedView && updatedMainViewsCount == 1) {
                        position = updatedMainViews[0].settings?.position === "left" ? "right" : "left";
                        weight = 100 - updatedMainViews[0].settings?.weight;
                      }
                      else if (mainViewsCount == 1) {
                        position = updatedMainViews[0].settings?.position === "left" ? "right" : "left";
                        weight = 50;
                      }

                      setFieldValue("views", views.map((v, i) => {

                        if (i == idx) {
                          return {
                            ...v,
                            is_main: true,
                            settings: {
                              ...v.settings,
                              position,
                              weight
                            }
                          };
                        }

                        if (v.is_main) {
                          return {
                            ...v,
                            settings: {
                              ...v.settings,
                              position: position === "left" ? "right" : "left",
                              weight: 100 - weight
                            }
                          };
                        }

                        return v;

                      }));

                    }
                    else {
                      setFieldValue("views", views.map((v, i) => {

                        if (i == idx) {
                          return {
                            ...v,
                            is_main: false,
                            settings: {}
                          };
                        }

                        if (v.is_main) {
                          return {
                            ...v,
                            settings: {
                              ...v.settings,
                              position: "left",
                              weight: 100
                            }
                          };
                        }

                        return v;

                      }));
                    }

                  }}
                />
                <h6 className="m-0 p-0" style={{ color: "#777" }}>{l("Vista principal%PA078")}</h6>

              </div>
            </div>

            {
              view.is_main &&
              <div className="ml-5 mt-2 mb-3">
                {
                  mainViewsCount == 2 && <>

                    <div className="d-flex justify-content-start align-items-center">
                      <h6 className="custom-view-field-label mr-2">{l("Posición%PA079")}</h6>
                      <Field
                        as="select"
                        name={`position_${idx}`}
                        id={`position_${idx}`}
                        className="form-control form-control-sm mb-2"
                        value={view?.settings?.position}
                        onChange={(e) => {
                          setFieldValue(
                            "views",
                            values?.views?.map((f, i) => {

                              if (i == idx) return {
                                ...f,
                                settings: {
                                  ...f.settings,
                                  position: e.target.value
                                }
                              };

                              if (f.is_main) {
                                return {
                                  ...f,
                                  settings: {
                                    ...f.settings,
                                    position: e.target.value == "left" ? "right" : "left"
                                  }
                                };
                              }

                              return f;

                            })
                          );
                        }}
                      >
                        <option value="left">{l("Izquierda%PA080")}</option>
                        <option value="right">{l("Derecha%PA081")}</option>
                      </Field>
                    </div>

                    <div className="d-flex justify-content-start align-items-center">
                      <h6 className="custom-view-field-label mr-2">{l("Ancho%PA082")} (%)</h6>
                      <Field
                        type="number"
                        name={`weight_${idx}`}
                        id={`weight_${idx}`}
                        className="form-control form-control-sm mb-2"
                        value={view?.settings?.weight}
                        min="0"
                        max="100"
                        placeholder=""
                        onChange={(e) => {
                          setFieldValue(
                            "views",
                            values?.views?.map((f, i) => {

                              if (i == idx) return {
                                ...f,
                                settings: {
                                  ...f.settings,
                                  weight: e.target.value
                                }
                              };

                              if (f.is_main) {
                                return {
                                  ...f,
                                  settings: {
                                    ...f.settings,
                                    weight: 100 - e.target.value
                                  }
                                };
                              }

                              return f;

                            })
                          );
                        }}
                      />
                    </div>

                  </>
                }
              </div>
            }

            {
              !view.is_prebuilt &&
              <div className="ml-5 mt-2">

                <div className="d-flex justify-content-start align-items-center">
                  <h6 className="custom-view-field-label mr-2">{l("Icono%GA075")} (fab icon)</h6>
                  <Field
                    type="text"
                    name={`icon_${idx}`}
                    id={`icon_${idx}`}
                    className="form-control form-control-sm mb-2"
                    placeholder="Ej. fas fa-home"
                    value={view.icon}
                    onChange={(e) => {
                      setFieldValue(
                        "views",
                        values?.views?.map((f, i) => {
                          if (i == idx) return { ...f, icon: e.target.value };
                          return f;
                        })
                      );
                    }}
                  />
                </div>

                <div className="d-flex justify-content-start align-items-center">
                  <h6 className="custom-view-field-label mr-2">URL</h6>
                  <Field
                    type="text"
                    name={`url_${idx}`}
                    id={`url_${idx}`}
                    className="form-control form-control-sm mb-2"
                    placeholder="Ej. www.example.com"
                    value={view.url}
                    onChange={(e) => {
                      setFieldValue(
                        "views",
                        values?.views?.map((f, i) => {
                          if (i == idx) return { ...f, url: e.target.value };
                          return f;
                        })
                      );
                    }}
                  />
                </div>

                <div className="d-flex justify-content-start align-items-center">
                  <h6 className="custom-view-field-label mr-2">{l("Ancho REM%PA083")} (sug. 32)</h6>
                  <Field
                    type="number"
                    name={`width_${idx}`}
                    id={`width_${idx}`}
                    className="form-control form-control-sm mb-2"
                    placeholder="Ej.32"
                    value={view.width}
                    onChange={(e) => {
                      setFieldValue(
                        "views",
                        values?.views?.map((f, i) => {
                          if (i == idx) return { ...f, width: e.target.value };
                          return f;
                        })
                      );
                    }}
                  />
                </div>

              </div>
            }

          </div>
        </td>
      </tr>
    }

  </>;
}

export default ViewField;